import { render, staticRenderFns } from "./LoadingOliver.vue?vue&type=template&id=2fbb1e30"
import script from "./LoadingOliver.vue?vue&type=script&lang=js"
export * from "./LoadingOliver.vue?vue&type=script&lang=js"
import style0 from "./LoadingOliver.vue?vue&type=style&index=0&id=2fbb1e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports